module.exports = __webpack_public_path__ + "img/logo.e5c57feb.png";